import React, { useState, useEffect, useRef, use } from 'react';
import $ from 'jquery';
import { Button, Container, Row, Col, Card, Alert, Table, Spinner } from 'react-bootstrap';
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx'; 
import Header from '../Header';
import { useParams } from 'react-router-dom';

const Tqueries = () => {
    const [Queries, SetQuries] = useState([]);
    const tableRef = useRef(null);
    const { ticket_id } = useParams();
   

    useEffect(() => {
        if (Queries.length > 0 && tableRef.current) {
          const table = $(tableRef.current).DataTable({
            responsive: true,
            autoWidth: false,
            destroy: true, 
            paging: true,
            pageLength: 10, 
            lengthMenu: [10, 25, 50, 100], 
            columnDefs: [
              { targets: 0, responsivePriority: 1 },
              { targets: 1, responsivePriority: 2 },
              { targets: 2, responsivePriority: 3 },
              { targets: 3, responsivePriority: 4 },
              { targets: 4, responsivePriority: 5 },
              { targets: 5, responsivePriority: 6 },
            ],
          });
    
          return () => {
            table.destroy(); // Cleanup on unmount
          };
        }
      }, [Queries]);


    useEffect( () => {
        const fetchData = async () => {
            const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/VQuery/${ticket_id}`);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }        
            const result = await response.json(); 
            SetQuries(result || []);       
            console.log(result);     
        }
        fetchData(); 
    }, []);


     


    return(
        <>
            <Header/>
            <Container fluid className="shadow mx-1 px-3 bg-light rounded-3">
                <Row className="d-flex align-items-center justify-content-between p-3 mt-3">
                    <Col>
                        <h4 className="mb-0"> Ticket Queries</h4>
                    </Col>
                    <Col className='text-end'>
                        <Button variant="success" >
                             Export to Excel
                        </Button>
                    </Col>
                </Row>

                {/* {error && <Alert variant="danger">{error}</Alert>} */}

                <Card>
                    <Card.Header> Ticket Quries</Card.Header>
                    <Card.Body>
                        <div className='table-responsive'>
                             <Table ref={tableRef} striped bordered hover responsive>
                                <thead>
                                    <tr>
                                    <th>S.no</th>
                                    <th>Ticket Id</th>                   
                                    <th>Query</th>
                                    <th>Doc</th>
                                    <th>Response</th>    
                                    <th>Doc</th>                                
                                    <th>Query Date</th>
                                    <th>Reply Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Queries.length > 0 ? (
                                    Queries.map((Queries, index) => (
                                        <tr key={Queries.id}>
                                        <td>{index + 1}</td>                                        
                                        <td className="text-danger">{Queries.ticket_id || 'N/A'}</td>
                                        <td>{Queries.emp_query || 'N/A'}</td>
                                        <td>
                                            {Queries.emp_file ? (
                                            <a href={`https://apiaksharaconnect.aksharafinalytics.in/${Queries.emp_file}`} download={Queries.emp_file || 'N/A'} target='_blank'>
                                                <Button variant="warning" size="sm" className="ms-2">
                                                <FontAwesomeIcon icon={faDownload} /> Download
                                                </Button>
                                            </a>
                                            ) : (
                                            <span>N/A</span>
                                            )}
                                        </td>
                                        <td>{Queries.user_Description || 'N/A'}</td>
                                        <td>
                                            {Queries.file_path ? (
                                            <a href={`https://apiaksharaconnect.aksharafinalytics.in/${Queries.file_path}`} download={Queries.file_path || 'N/A'} target="_blank">
                                                <Button variant="warning" className="ms-2 p-1 m-1">
                                                <FontAwesomeIcon icon={faDownload} />
                                                    Documents
                                                </Button>
                                            </a>
                                            ) : (
                                            <span>N/A</span>
                                            )}
                                        </td>                                       
                                        <td>{Queries.doa || 'N/A'}</td>
                                        <td>{Queries.reply_date || 'N/A'}</td>
                                        </tr>
                                    ))
                                    ) : (
                                    <tr>
                                        <td colSpan="8" className='text-center'>No Tickets available</td>
                                    </tr>
                                    )}
                                </tbody>
                            </Table>

                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );


};

export default Tqueries;